import {
  ENGLISH,
  ENGLISH_VOCAB_NOTE,
  MATHS,
  MATHS_VOCAB_NOTE,
  Subject,
} from 'global/constants';
import ReadMore from './read-more';

type Props = {
  marginBottom?: number;
  subject: Subject;
  contentType: string;
};

const ReadMoreVocab = ({ subject, marginBottom, contentType }: Props) => {
  if (subject === MATHS || subject === ENGLISH) {
    return (
      <ReadMore
        contentType={contentType}
        content={subject === MATHS ? MATHS_VOCAB_NOTE : ENGLISH_VOCAB_NOTE}
        marginBottom={marginBottom}
      />
    );
  }
  return null;
};

export default ReadMoreVocab;
